// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import '../../../sdk/dw-min-2.6.5'
import Weblogin from '@wpsovs/vue-weblogin' // wps登陆
import api from './plugins/api' // 导入api接口
import Toast from './components/toast/toast.js'

Vue.config.productionTip = false
Vue.use(Weblogin)
Vue.use(Toast)
Vue.prototype.$api = api // 将api挂载到vue的原型上

dw.setAppKey('b4f64faacc4832c3')
dw.setDebug(false)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/modules/christmasPC-2019/main.js